export function openCountryModal(modalId, values){

    $("tr.selected", modalId).each(function(i, v){
        $(v).removeClass("selected");
    });

    $.each(values, function(i, v){
        var td = $(modalId + " td.countryCode[data-id='" + v + "']");
        if(td.length > 0){
            td.closest("tr").addClass("selected");
        }
    });

    $(modalId).modal("show");

    var backdrops = $(".modal-backdrop");
    if(backdrops.length == 2){
        $(backdrops[1]).css("z-index", "1050");
    }
}

export function setupCountryModal(modalId, saveCallback){

    var getCurrentlySelected = function(){
        var currentlySelected = [];
        $("tr.selected", modalId).each(function(i, v){
            var code = $(v).find(".countryCode").data("id");
            var name = $(v).find(".countryName").data("name");
            var iso2 = $(v).find(".countryCode").data("iso2");
            currentlySelected.push({
                code: code,
                name: name,
                iso2: iso2
            });
        });
        return currentlySelected;
    }
    
    $(".countryBack", modalId).click(function(e){
        $(modalId).modal("hide");
    });

    $(".countrySave", modalId).click(function(e){
        var currentlySelected = getCurrentlySelected();
        saveCallback(currentlySelected);
        $(modalId).modal("hide");
    });

    $("tbody tr", modalId).click(function(e){
        var countryCode = $(this).find(".countryCode").data("id");
        var countryName = $(this).find(".countryName").data("name");
        var countryIso2 = $(this).find(".countryCode").data("iso2");

        if(! countryCode || ! countryName) return;
        
        var selectedCountry = {
            code: countryCode,
            name: countryName,
            iso2: countryIso2
        };

        var currentlySelected = getCurrentlySelected();
        
        if(currentlySelected.map(function(e){return e.code}).indexOf(selectedCountry.code) == -1){
            currentlySelected.push(selectedCountry);
            $(this).addClass("selected");
        } else {
            currentlySelected.splice(currentlySelected.indexOf(selectedCountry), 1);
            $(this).removeClass("selected");
        }
    });
}